import * as S from './style.Loading';
import spiner from '../../assets/img/Spinner.gif';

const Loading = () => {
    return (
        <S.Container>
            {/* <div className="loading"></div>
            <div className="loading__text">loading</div> */}
            <img src={spiner} />
        </S.Container>
    );
}

export default Loading;
